(ns app.domain.meeting.model
  (:require [app.domain.group.model :as group-model]
            [app.domain.util :as du]
            [core.db.child-entity :as child]))

(defmethod group-model/get-authority-group :entity.type/meeting [meeting]
  (:meeting/authority-group meeting))

(def valid-pre-con-process-states
  #{:process.state/in-progress
    :process.state/submitted})


(defn valid-pre-con-meeting? [meeting-ent]
  (let [in-valid-state-fn (->> valid-pre-con-process-states
                               (apply du/in-process-state-fn))]
    (-> meeting-ent
        :entity/parent ;;pre-consultation
        in-valid-state-fn)))

(def phase-meetings
  (child/child-entities-of-type-fn :entity.type/meeting))

(defn meeting-pending? [phase]
  (->> phase
       phase-meetings
       (filter (du/in-state-fn :meeting.state/draft
                               :meeting.state/published))
       count
       pos?))
